<template>
  <div v-if="isShowBrandRecommend" class="brand-recommend-border">
    <el-divider></el-divider>
    <div class="brand-recommend-title">
      <!-- 左侧品牌信息 -->
      <div class="info">
        <!-- 品牌信息 -->
        <div
          class="brand-content"
          style="overflow: hidden"
          v-if="queryData.collectionBrandId !== '' && queryData.collectionBrandId !== null"
        >
          <img
            :src="queryData.collectionBrandLogoUrl"
            style="
              height: 50px;
              width: 50px;
              float: left;
              border: 1px solid #e6e6e6;
              border-radius: 50%;
              cursor:pointer;
            "
            @click="gotoBrand"
          />
          <div class="collection_brand">
              <!-- 品牌名字，评分和卖点 -->
              <div class="brand_name_rating">
                <a
                  href="javascript:void(0)"
                  @click="gotoBrand"
                  style="
                    font-size: 16px;
                    color: #262b2f;
                    text-decoration: underline;
                    font-weight: 500;
                    line-height:35px;
                    margin-left: 10px;
                    float:left;
                    cursor: pointer;
                  "
                  >{{ queryData.collectionBrandName }}
                </a>
                <!-- 评分区 queryData.collectionBdScore-->
                <div class="total-reviews" v-if="queryData['rating']" @click="showRating" >
                  <el-rate
                    v-model="queryData['rating']"
                    disabled
                    :allowHalf="true"
                    style="width: 85px;margin-top:-5px"
                    disabled-void-color="#000"
                    disabled-void-icon-class="el-icon-star-off"
                    :colors="colors"
                    text-color="#262B2F"
                    >
                  </el-rate>
                  <span class="ratingStr">{{queryData['ratingStr']}}</span>
                  <i class="el-icon-arrow-down" style="margin-top:-5px"></i>
                </div>
                <!-- 评分区 end -->
                <div v-if="queryData['brandIsVilocal']" class="brand-vilocal">ViLocal</div>
                <!-- <el-tag v-if="queryData.salesManager !== '' && queryData.salesManager !== null"  type="danger">Top Brand</el-tag> -->
              </div>
              <div v-if="(!isMobile || isIpad) && queryData.collectionBrandSellingPoint && queryData.collectionBrandId !== '' && queryData.collectionBrandId !== null" class="selling-point">
                  ({{queryData.collectionBrandSellingPoint}})
              </div>
          </div>
        </div>
      </div>
      <!-- 右侧的去品牌按钮 -->
      <div v-if="!isMobile" class="brand-recommend-more" @click="gotoBrand()">Shop All <span>{{productTotal}}</span>Products</div>
    </div>
    <div v-if="showRatingDialog && !isMobile"  class="rating-collection-pc"  ref="ratingCollection" >
      <p>
        <span>Product Quality</span>
        <el-rate v-model="queryData['descriptionRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F">
        </el-rate>
        <span class="rating">{{queryData['productQuality']}}</span>
      </p>
      <p>
          <span> Brand Service</span>
        <el-rate v-model="queryData['serviceRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F" >
        </el-rate>
        <span class="rating">{{queryData['brandServiceStr']}}</span>
      </p>
      <p>
        <span> Logistics Rating</span>
          <el-rate v-model="queryData['logisticsRating']" disabled  :allowHalf="true" :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off"  text-color="#262B2F">
        </el-rate>
        <span class="rating">{{queryData['logisticsRatingStr']}}</span>
      </p>
    </div>
    <div v-if="isMobile" class="ships-free">
      <div class="m-title" v-if="queryData.collectionBrandId !== '' && queryData.collectionBrandId !== null">
        <div class="m-title-logo">
          <img
          :src="queryData.collectionBrandLogoUrl"
          style="
            height: 45px;
            width: 45px;
            float: left;
            border: 1px solid #e6e6e6;
            border-radius: 50%;
            cursor:pointer;
          "
          @click="gotoBrand"
        />
        </div>
        <div class="m-title-text" style="position: relative;top: -10px;">
          <div>
            <a
              href="javascript:void(0)"
              @click="gotoBrand"
              style="
                font-size: 16px;
                color: #262b2f;
                font-weight: 500;
                cursor: pointer;
                font-family:Satoshi-Medium;
                text-decoration: none;
              "
              >{{ queryData.collectionBrandName }}</a
            >
          </div>

        </div>
        <!-- 评分区 begin-->
        <div class="total-reviews" v-if="queryData['rating']" @click="showRating">
          <el-rate
            v-model="queryData['rating']"
            disabled
            :allowHalf="true"
            style="width: 80px;"
            :colors="colors"
            disabled-void-color="#000"
            disabled-void-icon-class="el-icon-star-off"
            text-color="#262B2F">
          </el-rate>
          <span class="ratingStr">{{queryData['ratingStr']}}</span>
          <i class="el-icon-arrow-down"></i>
          <div class="rating-collection" v-if="showRatingDialog" ref="ratingCollection" >
            <p>
              <span>Product Quality</span>
              <el-rate v-model="queryData['descriptionRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F">
              </el-rate>
              <span class="rating">{{queryData['productQuality']}}</span>
            </p>
            <p>
                <span> Brand Service</span>
              <el-rate v-model="queryData['serviceRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F" >
              </el-rate>
              <span class="rating">{{queryData['brandServiceStr']}}</span>
            </p>
            <p>
              <span> Logistics Rating</span>
                <el-rate v-model="queryData['logisticsRating']" disabled  :allowHalf="true" :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off"  text-color="#262B2F">
              </el-rate>
              <span class="rating">{{queryData['logisticsRatingStr']}}</span>
            </p>
          </div>
        </div>
        <!-- 评分区 end -->
        <div v-if="queryData['brandIsVilocal']" class="brand-vilocal">ViLocal</div>
        <!-- <el-tag  v-if="queryData.salesManager !== '' && queryData.salesManager !== null"  type="danger">Top Brand</el-tag> -->
      </div>

      <div class="selling-point" v-if="queryData.collectionBrandId !== '' && queryData.collectionBrandId !== null && queryData.collectionBrandSellingPoint && isMobile" >({{queryData.collectionBrandSellingPoint}})</div>
    </div>
    <CardCom
      :data="list"
      :type="type"
      :isShowBrandTag="false"
      :isShowAddToCart="false"
      @buryingPoint="buryingPoint">
    </CardCom>
    <div v-if="isMobile" class="brand-recommend-more" @click="gotoBrand()">Shop All <span>{{productTotal}}</span>Products</div>
    <el-divider></el-divider>
  </div>
</template>

<script>
import { postAction } from '@/api/manage.js'
import CardCom from '../../components/card.vue'
export default {
  components: {
    CardCom
  },
  props: {
    queryData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isMobile: {
      type: Array,
      default: function() {
        return {}
      }
    },
    isIpad: {
      type: Array,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      type: 5,
      detail: {},
      showRatingDialog: false,
      colors: ['#000000', '#000000', '#000000'],
      productTotal: 0,
      list: [],
      isShowBrandRecommend: true,
      limit: 5
    }
  },
  created() {
    if (this.isMobile) {
      this.limit = 2
    }
  },
  methods: {
    buryingPoint(item) {
      let profile = 'staging'
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        profile = 'test'
      } else if (process.env.NODE_ENV === 'production') {
        profile = 'prod'
      }
      const buryingPointObject = {}
      buryingPointObject.productName = item.title
      buryingPointObject.brandName = item.collectionBrandName
      buryingPointObject.productLink = item.seoUrl
      buryingPointObject.productId = item.id
      mixpanel.track(profile + '_brand_more_click', buryingPointObject)
    },
    showRating() {
      this.showRatingDialog = !this.showRatingDialog
    },
    gotoBrand() {
      // 如果品牌id不是初始值说明该商品有 品牌信息
      if (this.queryData.collectionBrandId !== '') {
        this.$router.push({path: '/brand' + this.queryData.collectionBrandSeoUrl})
        // window.open(
        //   window.location.origin +
        //     '/brand' + this.queryData.collectionBrandSeoUrl
        // )
      }
    },

    async loadData(brandId, productId) {
      const data = {}
      data.collectionBrandId = brandId
      data.sortValue = 1
      data.pageNo = 1
      data.pageSize = 5
      data.filterGoodsId = productId
      if (this.isMobile) {
        data.pageSize = 6
        this.type = 4
      }
      // 请求品牌下的商品准备
      let res = await postAction('/es/searchGoods', data)
      const arr = []
      this.productTotal = res.result.total + 1
      if (res.result) {
        if (res.result.records && res.result.records.length < this.limit) {
          this.isShowBrandRecommend = false
          return
        }
      }
      res.result.records.map((item) => {
        arr.push({
          ...item,
          ...{
            title: item.title,
            img: item.imgUrl,
            stockNum: item.stockNum || 0,
            totalSales: item.importCount || 0,
            netPrice: item.rrp,
            price: item.wsp
          }
        })
      })
      this.list = arr
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/spu-detail.less";
.brand-recommend-border{
  max-width: 1400px;
  width: 93%;
  margin:0 auto;
  position: relative;
  .brand-recommend-title{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 28px;
  }
  .brand-recommend-more{
    width: 232px;
    height: 40px;
    background: #000000;
    border: 1px solid #262613;
    opacity: 1;
    font-size: 14px;
    line-height: 18px;
    color: #FFFFFF;
    font-family: Satoshi-Regular;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span{
      margin:0 5px;
    }
  }
  .info{
    width: 70%;
  }
  .selling-point{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  .rating-collection-pc{
    z-index: 9999;
    position: absolute;
    width: 300px;
    height: 140px;
    background: #FFFFFF;
    //border: 1px solid #F0F0F0;
    border: 1px solid #E1E1E1;
    top: 73px;
    left: 140px;
    font-size: 14px;
    p{
      display: flex;
      padding: 0 10px;
      height: 30px;
      justify-content: space-between;
      margin-top: 10px;
    }
    p span{width: 100px;margin-left:20px;}
    span{
      margin-top: 5px;
    }
    .el-rate{position: relative;top: 6px;margin-left: 10px;}
  }
  .rating-collection-pc:before{
    width: 0px;
    height: 0px;
    position: absolute;
    top: -24px;
    left: 90px;
    padding: 0;
    border-bottom: 12px solid #FFFFFF;
    border-top: 12px solid transparent;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    content: '';
    z-index: 12;
  }
  .rating-collection-pc:after{
    width: 0px;
    height: 0px;
    position: absolute;
    top: -26px;
    left: 89px;
    padding: 0;
    border-bottom: 13px solid #E1E1E1;
    border-top: 13px solid transparent;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    content: '';
    z-index: 10;
  }
}
@media screen and (max-width: 600px) {
  .brand-recommend-border{
    width: 94.5%;
  }
  .brand-recommend-more{
    width: 60% !important;
    margin:0 auto;
    margin-bottom: 10px;
  }
  .m-title{
    width: 100%;
    margin:0 auto;
  }
  .ships-free{
    margin-bottom: 30px !important;
    .m-title{
      border-top:none !important
    }
  }
  .selling-point{
    top: 65px;
    width: 80% !important;
    overflow: hidden;

  }
  /deep/ .rating-collection::before{
    right: 41% !important;
  }
  /deep/ .rating-collection::after{
    right: calc(41% - 1px)!important;
  }
  .rating-collection{
    left: -110px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/recommend/brand-recommend.vue